"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiComparison = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../../model");
var KpiComparisonTypeDropdown_1 = require("./KpiComparisonTypeDropdown");
var KpiComparisonDirectionDropdown_1 = require("./KpiComparisonDirectionDropdown");
exports.KpiComparison = function (props) {
    var widget = props.widget;
    var ref = sdk_model_1.widgetRef(widget);
    var comparisonDirection = widget.kpi.comparisonDirection;
    var comparisonType = widget.kpi.comparisonType;
    var dispatch = model_1.useDashboardDispatch();
    var handleComparisonTypeChanged = react_1.useCallback(function (newComparisonType) {
        dispatch(model_1.changeKpiWidgetComparison(ref, {
            comparisonDirection: comparisonDirection,
            comparisonType: newComparisonType,
        }));
    }, [dispatch, ref, comparisonDirection]);
    var handleComparisonDirectionChanged = react_1.useCallback(function (newComparisonDirection) {
        dispatch(model_1.changeKpiWidgetComparison(ref, {
            comparisonType: comparisonType,
            comparisonDirection: newComparisonDirection,
        }));
    }, [dispatch, ref, comparisonType]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.compareWith", tagName: "label" }),
        react_1.default.createElement(KpiComparisonTypeDropdown_1.KpiComparisonTypeDropdown, { comparisonType: comparisonType, onComparisonTypeChanged: handleComparisonTypeChanged }),
        !!comparisonDirection && (react_1.default.createElement(KpiComparisonDirectionDropdown_1.KpiComparisonDirectionDropdown, { comparisonDirection: comparisonDirection, onComparisonDirectionChanged: handleComparisonDirectionChanged }))));
};
//# sourceMappingURL=KpiComparison.js.map